// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.TrackingPage_page__OeeMA {
  padding: 20px;
}

.TrackingPage_header__xyLON {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}

.TrackingPage_cards__ILmSL {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(220px, 1fr));
  gap: 12px;
}

.TrackingPage_card__Bs2ez {
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 2px 6px rgba(0,0,0,0.08);
  padding: 16px;
  cursor: pointer;
  transition: transform 0.2s ease;
}

.TrackingPage_card__Bs2ez:hover {
  transform: translateY(-2px);
}

h2 {
  margin-top: 30px;
  margin-bottom: 10px;
}
`, "",{"version":3,"sources":["webpack://./src/modules/Logist/Tracking/TrackingPage.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,4DAA4D;EAC5D,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,sCAAsC;EACtC,aAAa;EACb,eAAe;EACf,+BAA+B;AACjC;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;AACrB","sourcesContent":[".page {\r\n  padding: 20px;\r\n}\r\n\r\n.header {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  margin-bottom: 20px;\r\n}\r\n\r\n.cards {\r\n  display: grid;\r\n  grid-template-columns: repeat(auto-fill, minmax(220px, 1fr));\r\n  gap: 12px;\r\n}\r\n\r\n.card {\r\n  background: #fff;\r\n  border-radius: 12px;\r\n  box-shadow: 0 2px 6px rgba(0,0,0,0.08);\r\n  padding: 16px;\r\n  cursor: pointer;\r\n  transition: transform 0.2s ease;\r\n}\r\n\r\n.card:hover {\r\n  transform: translateY(-2px);\r\n}\r\n\r\nh2 {\r\n  margin-top: 30px;\r\n  margin-bottom: 10px;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"page": `TrackingPage_page__OeeMA`,
	"header": `TrackingPage_header__xyLON`,
	"cards": `TrackingPage_cards__ILmSL`,
	"card": `TrackingPage_card__Bs2ez`
};
export default ___CSS_LOADER_EXPORT___;
